module.exports = /[-\s]+(.)?/g;